// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Creativity_wrapper__LO0pp","chatOpen":"Creativity_chatOpen__18_ws"};